import React from 'react'
import PredictiveSearch from './predictive-search'
import RecentSearches from './recent-searches'
import SavedSearches from './saved-searches'
import useGlobalSearch from './use-global-search'

export default () => {
    const {inputRef, resultRef,
        mode, prevMode, Modes, keyword,
        onSearch,
        onFocus, onClear, onBlur, onKeyPress, onKeyDown, onChange
    } = useGlobalSearch()

    return (<React.Fragment>
    <div className="form-group">

    <div className="form-icon-group icon-left" style={{overflow:"visible"}}>
        <i className="material-icons" aria-hidden="true" style={{color:'var(--primary-base-color)'}}>search</i>
        <input
            data-name="global-search"
            ref={inputRef}
            type="text"
            className="form-control"
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyUp={onKeyPress}
            onKeyDown={onKeyDown}
            onChange={onChange}
            placeholder="CUSIP, Company Name, or Stock Symbol"
            aria-label="Search"
        >
        </input>

        { mode!==Modes.NONE && (
            <button
                aria-hidden="true"
                data-name="global-search-clear"
                onClick={onClear}
                tabIndex={-1}
                style={{
                    position: 'absolute',
                    top: 0,
                    right: '25px',
                    zIndex: 2,
                    cursor:'pointer',
                    background: '0 0',
                    border: 'none'
                }}
            ><i className="material-icons" aria-hidden="true" style={{
                pointerEvents:'auto'
            }}>clear</i></button>
        )}

        <div
            ref={resultRef}
            onMouseOver={()=> {
                if (!(mode===Modes.SARCH || mode===Modes.SHOW_LAST)) return
                resultRef.current.setAttribute('mouse-on-result', 'Y')
            }}
            onMouseOut={() => {
                resultRef.current.removeAttribute('mouse-on-result')
            }}
        >
        {(() => {
            const refresh = mode===Modes.SHOW_LAST
                && prevMode === Modes.NONE

            return mode===Modes.SEARCH ? (
                <PredictiveSearch onSearch={onSearch} keyword={keyword} />
            ) :
            mode===Modes.SHOW_LAST ? (
                <div className="auto-suggest-menu">
                <div style={{overflow:'hidden', margin:'10px'}}>
                <RecentSearches onSearch={onSearch} refresh={refresh} />
                <SavedSearches onSearch={onSearch} refresh={refresh} />
                </div>
                </div>
            ) : null
        })()}
        </div>
    </div>

    </div>
    </React.Fragment>)
}



// WEBPACK FOOTER //
// ./src/header/global-search/global-search.js